import {Directive, ElementRef, forwardRef, HostListener} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from "@angular/forms";

@Directive({
  selector: '[lettersOnly]',
  standalone: true,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AllowOnlyLettersDirective),
      multi: true
    }
  ]
})
export class AllowOnlyLettersDirective implements ControlValueAccessor {

  regexStr = '^[a-zA-Z ]+$';
  regExp = /[^a-zA-Z ]/g;

  // tslint:disable-next-line:variable-name
  constructor(private _el: ElementRef) { }

  onChange: any = () => {};
  onTouched: any = () => {};

  @HostListener('input', ['$event.target.value'])
  onInput(value: string) {
    this.onChange(value.replace(this.regExp, ''));
    this.onTouched();
  }

  @HostListener('blur')
  onBlur() {
    this.onTouched();
  }

  writeValue(value: any): void {
    this._el.nativeElement.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this._el.nativeElement.disabled = isDisabled;
  }

  @HostListener('keypress', ['$event'])
  onKeyPress(event: KeyboardEvent) {
    return new RegExp(this.regexStr).test(event.key);
  }

  @HostListener('paste', ['$event'])
  blockPaste(event: ClipboardEvent) {
    this.validateField(event);
  }

  private validateField(event: ClipboardEvent) {
    event.preventDefault();
    let data = event.clipboardData?.getData('text/plain').replace(this.regExp, '');
    this._el.nativeElement.value = data;
    this.writeValue(data)
    this.onChange(data)
    this.onTouched();
  }
}
